import { useEffect } from "react";

export const useRedirectToEffect = (pathName: string, trigger: boolean) => {
  useEffect(() => {
    if (trigger) {
      const path = pathName.startsWith("/") ? pathName : `/${pathName}`;

      window.location.pathname !== path && (window.location.href = path);
    }
  }, [trigger]);
};
